import { Badge } from '~/components/ui/badge';

export type OpenBillingDraftPaymentStatus = 'UNDERPAID' | 'OVERPAID' | 'OTHER';

export type OpenBillingDraftEntry = {
    billingDraftId: string;
    billingDraftNumber: string;
    billingDraftDate: string;
    status: string;
    storeId: number;
    storeName: string;
    customerId: number;
    customerName: string;
    totalCents: number;
    paidCents: number;
    paymentStatus: OpenBillingDraftPaymentStatus;
};

const OpenBillingDraftStatusBadge = ({ status }: { status: OpenBillingDraftPaymentStatus }) => {
    if (status === 'UNDERPAID') {
        return (
            <Badge variant='outline' className='bg-red-100 text-red-800 border-red-200'>
                Zahlung ausstehend
            </Badge>
        );
    }
    if (status === 'OVERPAID') {
        return (
            <Badge variant='outline' className='bg-amber-100 text-amber-800 border-amber-200'>
                Überzahlung
            </Badge>
        );
    }
    return (
        <Badge variant='outline' className='bg-gray-100 text-gray-800 border-gray-200'>
            Sonstige
        </Badge>
    );
};

export default OpenBillingDraftStatusBadge;
